<template>
    <div id="budget_issues" class="container-fluid">
        <router-link class="btn btn-secondary main-button ml-2 pull-right" :to="{ path: '/budget/issues/excluded/classifications'}" style="pointer-events:initial !important;">Excluded Classifications</router-link>
        <router-link class="btn btn-secondary main-button ml-2 pull-right" :to="{ path: '/budget/issues/unclassified/campaigns'}" style="pointer-events:initial !important;">Unclassified Campaigns</router-link>
        <button class="btn btn-secondary main-button reverse unclickable pull-right" style="pointer-events:initial !important;">Missing Clients</button>
        <h5 class="text-center my-3">Clients in the budget sheet not found in the interface</h5>
        <v-client-table :data="tableData" :columns="columns" :options="options"></v-client-table>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        data() {
            return {
                tableData: [],
                columns: ['sheet_owner', 'client_name'],
                options: {
                    headings: {
                        sheet_owner: 'Sheet Owner',
                        client_name: 'Client'
                    },
                    sortable: ['sheet_owner', 'client_name'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} missing clients|{count} missing clients|One missing client',
                        filter: '',
                        filterPlaceholder: 'Search ...',
                        noResults: 'No matching missing client'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get('/api/budget/issues')
                ])
                .then(axios.spread((issues) => {
                    this.tableData = issues.data;
                }));
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
